<template>
    <div class="layer-popup basic open">
      <div class="layer-content">
        <button type="button" class="btn-close close-layer" @click="this.closePop">팝업 닫기</button>
        <div class="scroll-box">
          <h4 class="list-title">{{this.popupData.title}}</h4>
          <div class="list-text-area">{{this.popupData.contents}}</div>
          <p class="list-date">{{this.popupData.date}}</p>
        </div>
      </div>
    </div>
</template>
<script>

export default {
  name: 'components-popup',
  components: {

  },
  props: ["popupData"],
  methods: {
    closePop() {
      this.$emit('close');
    }
  }

}

</script>